import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { WebEvent, WebEventID } from '@playq/octopus2-admin';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { webEventGetKeys } from './constants';

export const useWebEventGet = (
  id?: WebEventID,
  options?: IUseQueryOptionsExtended<WebEvent | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => webEventGetKeys.concat(id), [id]);

  const res = useEitherQuery(keys, () => services2.webEventsService.retrieve(id as WebEventID), {
    placeholderData: keepPreviousData,
    ...options,
    enabled: options?.enabled !== false && id !== undefined,
  });

  return {
    webEvent: res.data,
    ...res,
    tags: keys,
  };
};
